// iscmdpanel
import { DropdownPanelView } from 'ckeditor5';
import IsCmdToolbar from './iscmdtoolbar.js';

/*
// Icons, seems they must be imported individually, at least CKEditor does so in ckeditor5-core/index.js
import eraseIcon from '@ckeditor/ckeditor5-core/theme/icons/eraser.svg';
// Own icons, partially handcrafted
import freePenIcon from '../../theme/icons/free-line.svg';
import straightLinesIcon from '../../theme/icons/normal-line.svg';
import blackIcon from '../../theme/icons/black-tile.svg';
import redIcon from '../../theme/icons/red-tile.svg';
import greenIcon from '../../theme/icons/green-tile.svg';
import blueIcon from '../../theme/icons/blue-tile.svg';
import thinIcon from '../../theme/icons/thin.svg';
import mediumIcon from '../../theme/icons/medium.svg';
import thickIcon from '../../theme/icons/thick.svg';
import xthickIcon from '../../theme/icons/xthick.svg';
*/


const freePenIcon = '<?xml version="1.0" encoding="utf-8"?><svg viewBox="0 0 1024 1024" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M722.081 962a35.906 35.906 0 0 1-17.349-4.49c-11.407-6.286-19.007-18.232-19.007-31.953 0-6.39 1.648-12.396 4.543-17.614 66.271-121.868 227.635-466.192 177.528-592.736-7.402-18.684-19.048-30.089-36.64-35.913-56.781-18.684-139.404 79.469-212.322 166.217-75.465 89.66-146.806 174.346-222.634 180.413-29.361 2.305-56.417-7.037-80.318-27.784-74.979-64.91-24.872-188.905 19.291-298.221 23.173-57.266 54.839-135.765 43.434-159.787-.486-1.091-1.456-3.033-7.159-4.732-44.769-13.953-156.39 123.146-228.578 254.785-9.706 17.592-31.788 24.143-49.38 14.438-17.592-9.706-24.143-31.788-14.438-49.38C121.516 277.715 269.777 27.904 393.045 66c23.659 7.402 41.373 22.203 51.321 43.071 24.994 52.777-5.945 129.455-41.737 218.267-33.244 82.381-74.737 185.023-39.067 215.962 11.648 10.071 20.504 10.798 26.934 10.192 45.498-3.639 113.077-83.836 172.648-154.691 92.087-109.436 187.328-222.513 290.819-188.42 38.096 12.496 66.244 39.552 81.532 78.255 71.583 180.898-155.299 606.511-181.384 654.435-6.551 12.011-19.048 18.927-32.03 18.927z"/></svg>';
const straightLinesIcon = '<?xml version="1.0" encoding="utf-8"?><svg viewBox="0 -51.5 1127 1127" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="m84.801 962 277.291-477.603L71.597 130.971c-5.972-7.215-9.595-16.565-9.595-26.76 0-23.258 18.855-42.113 42.113-42.113 13.063 0 24.738 5.948 32.463 15.283l327.776 398.728-210.005 361.714 616.529-137.522 98.611-563.852c3.631-19.953 20.875-34.882 41.605-34.882 2.522 0 4.992.22 7.391.644 22.643 4.037 37.954 25.81 34.021 48.706L944.344 770.255 84.8 961.998z"/></svg>';
const eraseIcon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>';
const blackIcon = '<?xml version="1.0" encoding="utf-8"?><svg viewBox="0 0 1000 1000" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"><rect x="100" y="100" rx="100" ry="100" width="800" height="800" fill="#000000"/></svg>';
const redIcon = '<?xml version="1.0" encoding="utf-8"?><svg viewBox="0 0 1000 1000" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"><rect x="100" y="100" rx="100" ry="100" width="800" height="800" fill="#FF0000"/></svg>';
const greenIcon = '<?xml version="1.0" encoding="utf-8"?><svg viewBox="0 0 1000 1000" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"><rect x="100" y="100" rx="100" ry="100" width="800" height="800" fill="#008000"/></svg>';
const blueIcon = '<?xml version="1.0" encoding="utf-8"?><svg viewBox="0 0 1000 1000" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"><rect x="100" y="100" rx="100" ry="100" width="800" height="800" fill="#0000FF"/></svg>';
const thinIcon = '<?xml version="1.0" encoding="utf-8"?><svg viewBox="0 0 1000 1000" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"><line x1="100" y1="500" x2="900" y2="500" stroke="black" stroke-width="20"/></svg>';
const mediumIcon = '<?xml version="1.0" encoding="utf-8"?><svg viewBox="0 0 1000 1000" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"><line x1="100" y1="500" x2="900" y2="500" stroke="black" stroke-width="80"/></svg>';
const thickIcon = '<?xml version="1.0" encoding="utf-8"?><svg viewBox="0 0 1000 1000" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"><line x1="100" y1="500" x2="900" y2="500" stroke="black" stroke-width="160"/></svg>';
const xthickIcon = '<?xml version="1.0" encoding="utf-8"?><svg viewBox="0 0 1000 1000" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"><line x1="100" y1="500" x2="900" y2="500" stroke="black" stroke-width="240"/></svg>';

export default class IsCmdPanel extends DropdownPanelView {

    /**
     * 
     * @param {*} locale 
     */
    constructor( locale ) {
        super( locale );
       
        const modeToolbar = new IsCmdToolbar(
            locale,
            [
                {
                    customid: 'freePen',
                    labeltext: 'free pen mode',
                    tooltip: true,
                    icon: freePenIcon
                },
                {
                    customid: 'straightLines',
                    labeltext: 'straight lines mode',
                    tooltip: true,
                    icon: straightLinesIcon
                },
                {
                    customid: 'erase',
                    labeltext: 'erase mode',
                    tooltip: true,
                    icon: eraseIcon
                }
            ],
            { 
                defaultCustomid: 'freePen'
            }
        );
        this.bind('mode').to(modeToolbar, 'activeCustomid');

        const colorToolbar = new IsCmdToolbar(
            locale,
            [
                {
                    customid: 'black',
                    labeltext: 'set black color',
                    tooltip: true,
                    icon: blackIcon
                },
                {
                    customid: 'red',
                    labeltext: 'set red color',
                    tooltip: true,
                    icon: redIcon
                },
                {
                    customid: 'green',
                    labeltext: 'set green color',
                    tooltip: true,
                    icon: greenIcon
                },
                {
                    customid: 'blue',
                    labeltext: 'set blue color',
                    tooltip: true,
                    icon: blueIcon
                }
            ],
            {
                defaultCustomid: 'black'
            }
        );
        this.bind('color').to(colorToolbar,'activeCustomid');

        const strokeToolbar = new IsCmdToolbar(
            locale,
            [
                {
                    customid: 'thin',
                    labeltext: 'set thin stroke',
                    tooltip: true,
                    icon: thinIcon
                },
                {
                    customid: 'medium',
                    labeltext: 'set medium stroke',
                    tooltip: true,
                    icon: mediumIcon
                },
                {
                    customid: 'thick',
                    labeltext: 'set thick stroke',
                    tooltip: true,
                    icon: thickIcon
                },
                {
                    customid: 'xthick',
                    labeltext: 'set xthick stroke',
                    tooltip: true,
                    icon: xthickIcon
                }
            ],
            {
                defaultCustomid: 'medium'
            }
        );
        this.bind('stroke').to(strokeToolbar, 'activeCustomid');

        this.setTemplate( {
            tag: 'div',
            attributes: {
                style: {
                    width: '180px'
                }
            },
            children:[
                modeToolbar,
                colorToolbar,
                strokeToolbar
            ]
        } );

        this.on( 'change', () => console.log( 'mode changed to', this.mode ) );
    }
}